import { FadeUp } from '../primitives/FadeUp';
import { SectionH2 } from '../primitives/SectionH2';
import { FormEmbed } from '../hero/FormEmbed';
import { useIsMobile } from '../../hooks/useIsMobile';
import { ACCENT, FONT_MONO, MUTED, TEXT_SECONDARY } from '../../tokens';

export function CtaSection() {
  const isMobile = useIsMobile();

  return (
    <section
      id="cta"
      style={{
        padding: isMobile ? '80px 20px' : '130px 64px',
        background: 'rgba(6,6,6,0.88)',
        textAlign: 'center',
      }}
    >
      <div style={{ maxWidth: 700, margin: '0 auto' }}>
        <FadeUp>
          <div
            style={{
              fontFamily: FONT_MONO,
              fontSize: '0.7rem',
              color: ACCENT,
              letterSpacing: '0.12em',
              textTransform: 'uppercase',
              marginBottom: 24,
            }}
          >
            Ready?
          </div>

          <SectionH2 style={{ marginBottom: 16 }}>See the gap before you commit to closing it.</SectionH2>

          <p style={{ color: TEXT_SECONDARY, fontSize: '1.1rem', lineHeight: 1.75, marginBottom: 36 }}>
            I scan your competitors and send you what they are posting that you are not, what people
            are asking them in the comments, and where the gaps are in your market. Free, and yours to
            keep whether we ever work together or not. No pitch, no deck.
          </p>

          <div style={{ marginBottom: 16 }}>
            <FormEmbed />
          </div>

          <span style={{ fontFamily: FONT_MONO, fontSize: '0.65rem', color: MUTED, letterSpacing: '0.08em' }}>
            FREE. NO OBLIGATION. YOURS TO KEEP EITHER WAY.
          </span>
        </FadeUp>
      </div>
    </section>
  );
}
